<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @export="openExport"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <chooseTemplate
      :visible.sync="exportOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-shipmentList' }"
      :exportOptions="{
        params: { shipmentCode: exportOptions.shipmentCode },
        checkUrl: '/ecom/shipment/info/exportCheck',
      }"
    />
  </div>
</template>

<script>
import PageHeader from './header'
import PageMain from './main.vue'
import chooseTemplate from '@/views/ecom/components/choose-template'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'

export default {
  components: { PageHeader, PageMain, chooseTemplate },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      exportOptions: { visible: false, shipmentCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomShipmentInfoListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, row }) {
      this.$router.push({
        name: 'ecom-shipment-management-shipment-orders-detail',
        params: { pageType, shipmentCode: row.shipmentCode },
        query: { shipmentNo: row.shipmentNo },
      })
    },
    openExport(row) {
      this.exportOptions = { visible: true, shipmentCode: row.shipmentCode }
    },
  },
}
</script>
